import styled from 'styled-components';

const StyledBarContainer = styled.div`
  width: 100%;
  height: 4px;
  border-radius: 2px;
`;

export default StyledBarContainer;
